import { publicInstance } from 'core/http-common'

export interface IDictionaryList {
  id: number
  keyword: string
  tr: string
  en: string
}

class DictionaryService {
  // Uses the public (no-auth-interceptor) instance: the endpoint is [AllowAnonymous] and can be called
  // before login, so it must NOT go through the auth instance (which redirects a token-less user to
  // /logout — the pre-login white-screen / redirect loop).
  //
  // BUT when the caller IS already logged in (useDictionary runs on authenticated pages), we still attach
  // ChronosAuth / WebApiKey / userId so the request carries auth on the web side just like every other
  // call — best-effort: headers are added only when present, so the token-less pre-login case is untouched.
  getDictionaryList() {
    const token = localStorage.getItem('token')
    const webApiKey = localStorage.getItem('webApiKey')
    const employee = JSON.parse(localStorage.getItem('employee') || '{}')

    const headers: Record<string, string> = {}
    if (token) headers['ChronosAuth'] = token
    if (webApiKey) headers['WebApiKey'] = webApiKey
    if (employee?.id) headers['userId'] = String(employee.id)
    if (token) headers['os'] = 'WEB'

    return publicInstance.get<IDictionaryList[]>(`Dictionary/GetDictionaryList`, { headers })
  }
}
export default new DictionaryService()
